import { combineReducers } from 'redux';
import app from './app';
import authentication from './authentication';
import billing from './billing';
import cases from './cases';
import contractGenerationsMonthly from './contractGenerationsMonthly';
import dailyBattery from './dailyBattery';
import documents from './documents';
import feedback from './feedback';
import hourlyBattery from './hourlyBattery';
import hourlyProduction from './hourlyProduction';
import notifications from './notifications';
import payments from './payments';
import support from './support';
import system from './system';
import unsavedApp from './unsavedApp';
import user from './user';

export default combineReducers({
  app,
  authentication,
  billing,
  cases,
  contractGenerationsMonthly,
  dailyBattery,
  documents,
  feedback,
  hourlyBattery,
  hourlyProduction,
  notifications,
  payments,
  support,
  system,
  unsavedApp,
  user,
});
